import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { CourseView, lessonListQueryOptions } from '@/modules/lessonDetails'
import { courseQueryOptions } from '@/queries/useCourse'

export const Route = createFileRoute('/_auth/timetable/$courseId/$groupId')({
  component: () => (
    <CourseView>
      <Outlet />
    </CourseView>
  ),
  validateSearch: z.object({
    lessonId: z.string().optional()
  }),
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ params, context, deps: { search }, location }) => {
    const course = await context.queryClient.ensureQueryData(
      courseQueryOptions(params.courseId)
    )

    const lessonList = await context.queryClient.ensureQueryData(
      lessonListQueryOptions(params.groupId)
    )

    const closestLessonId = lessonList.closestLesson.id

    if (!search.lessonId) {
      throw redirect({
        to: location.pathname,
        replace: true,
        search: { lessonId: closestLessonId, ...search },
        params: { courseId: params.courseId, groupId: params.groupId }
      })
    }
    return course.name
  }
})
